// Auth logging. Masks sensitive values.
__LOG_INFO__ && AppLog.info('[AUTH] auth.js LOADED (synchronous script start)');
// Force console level restoration
try {
    if (typeof originalConsoleLog === 'undefined' || !originalConsoleLog) {
        window.originalConsoleLog = console.log;
        window.originalConsoleInfo = console.info;
        window.originalConsoleWarn = console.warn;
        window.originalConsoleError = console.error;
    }
} catch(e) {}

// Shared auth logging utility. Uses the global logger when available.

function _maskToken(tok){ try{ if(!tok) return ''; const s=String(tok); return s.length>12 ? (s.slice(0,6)+"…"+s.slice(-6)) : '***'; } catch(_){ return '***'; } }
function _uidTail(u){ try{ return u ? String(u).slice(-6) : null; } catch(_){ return null; } }
function dbg(tag, obj){
    try {
        AppLog.info(`[AUTH][${tag}]`, obj || '');
    } catch(_){}
}

function getAuthAnalyticsSurface() {
    try {
        const path = String(window.location.pathname || '').toLowerCase();
        if (path.includes('vr')) return 'VR';
        if (path.includes('desktop') || path.includes('mobiletest')) return 'Desktop';
        if (path.includes('authtest')) return 'AuthTest';
    } catch (_) {}
    return 'Web';
}

function getAuthAnalyticsPrefix() {
    const surface = getAuthAnalyticsSurface();
    if (surface === 'VR') return 'VR_TopNav_Account';
    if (surface === 'Desktop') return 'Desktop_TopNav_Account';
    return `${surface}_Account`;
}

function trackAuthAnalyticsEvent(eventName, params) {
    try {
        if (window.gtag) {
            window.gtag('event', eventName, params || {});
        }
    } catch (e) {
        __LOG_WARN__ && AppLog.warn('[AUTH][analytics] Failed to send event', { eventName, error: e.message });
    }
}

function trackAccountSignupSuccess(flow, result) {
    const surface = getAuthAnalyticsSurface();
    const confirmationRequired = !(result && result.session);
    const params = {
        method: 'email',
        account_flow: flow,
        surface,
        email_confirmation_required: confirmationRequired
    };

    trackAuthAnalyticsEvent('sign_up', params);
    trackAuthAnalyticsEvent(`${getAuthAnalyticsPrefix()}_${flow === 'anonymous_upgrade' ? 'UpgradeSuccess' : 'NewAccountSuccess'}`, params);
}

// Build-time AUTH_DISABLE_ANONYMOUS hydration (env + runtime override)
(function(){
  try {
    __LOG_INFO__ && AppLog.info('[AUTH] Global scope check:', {
        hasConsole: !!console, 
        hasLog: !!console.log,
        hasInfo: !!console.info,
        pathname: window.location.pathname
    });
  } catch(e) {}
  
  if (__LOG_INFO__) AppLog.info('[AUTH] Build-time hydration: starting...');
  try {
    const isAuthTest = window.location.pathname.includes('authtest.html');
    __LOG_INFO__ && AppLog.info('[AUTH] Build-time hydration check:', { isAuthTest, pathname: window.location.pathname });
    
    function normalizeBoolean(v){
      if (typeof v === 'boolean') return v;
      if (v == null) return false;
      const s = String(v).trim().toLowerCase();
      return s === '1' || s === 'true' || s === 'yes' || s === 'on';
    }
    // Only set from env if the page hasn't already set a runtime override
    if (typeof window.AUTH_DISABLE_ANONYMOUS === 'undefined') {
      try {
        if (typeof __AUTH_DISABLE_ANONYMOUS__ !== 'undefined') {
          window.AUTH_DISABLE_ANONYMOUS = normalizeBoolean(__AUTH_DISABLE_ANONYMOUS__);
          if (__LOG_INFO__) dbg('INIT', { msg: 'AUTH_DISABLE_ANONYMOUS hydrated from build-time env', value: window.AUTH_DISABLE_ANONYMOUS });
        } else if (typeof AUTH_DISABLE_ANONYMOUS !== 'undefined') {
          // Fallback if __ prefix is missing
          window.AUTH_DISABLE_ANONYMOUS = normalizeBoolean(AUTH_DISABLE_ANONYMOUS);
          if (__LOG_INFO__) dbg('INIT', { msg: 'AUTH_DISABLE_ANONYMOUS hydrated from build-time env (no __)', value: window.AUTH_DISABLE_ANONYMOUS });
        } else {
          // If no build-time variable, try to fetch it from the server
          if (__LOG_INFO__) dbg('INIT', { msg: 'AUTH_DISABLE_ANONYMOUS not found in build-time env - falling back to server check shortly' });
          setTimeout(async () => {
            if (typeof window.AUTH_DISABLE_ANONYMOUS === 'undefined') {
                try {
                    const resp = await fetch('/api/auth/config');
                    if (resp.ok) {
                        const cfg = await resp.json();
                        if (cfg && typeof cfg.AUTH_DISABLE_ANONYMOUS !== 'undefined') {
                            window.AUTH_DISABLE_ANONYMOUS = normalizeBoolean(cfg.AUTH_DISABLE_ANONYMOUS);
                            if (__LOG_INFO__) dbg('INIT_FETCH', { msg: 'AUTH_DISABLE_ANONYMOUS hydrated from server', value: window.AUTH_DISABLE_ANONYMOUS });
                        }
                    }
                } catch (e) {
                    if (__LOG_INFO__) dbg('INIT_FETCH_ERROR', { error: e.message });
                }
            }
          }, 0);
        }
      } catch(_) { /* DefinePlugin may not inject in some pages */ }
    } else {
      if (__LOG_INFO__) dbg('INIT', { msg: 'AUTH_DISABLE_ANONYMOUS already set on window', value: window.AUTH_DISABLE_ANONYMOUS });
    }
    // Expose for internal use
    window.__authNormalizeBool = normalizeBoolean;
  } catch(_) {}
})();

// Replace the NUDGE_CONFIG section with simplified config:
const NUDGE_CONFIG = {
    // Time (in days) before prompting anonymous users to complete their account
    ACCOUNT_COMPLETION_PROMPT_DAYS: 2,
    
    // For testing purposes, you can use minutes instead
    USE_MINUTES_FOR_TESTING: true,
    
    // Alternative testing values (in minutes)
    ACCOUNT_COMPLETION_PROMPT_MINUTES: 2
};

// Update helper functions:
function getTimeThreshold() {
    if (NUDGE_CONFIG.USE_MINUTES_FOR_TESTING) {
        return NUDGE_CONFIG.ACCOUNT_COMPLETION_PROMPT_MINUTES;
    } else {
        return NUDGE_CONFIG.ACCOUNT_COMPLETION_PROMPT_DAYS;
    }
}

// Helper function to calculate time difference
function getTimeSinceCreation(createdAt) {
    const now = new Date();
    const created = new Date(createdAt);
    
    if (NUDGE_CONFIG.USE_MINUTES_FOR_TESTING) {
        return Math.floor((now - created) / (1000 * 60)); // Minutes
    } else {
        return Math.floor((now - created) / (1000 * 60 * 60 * 24)); // Days
    }
}

// Lightweight nudge glue (reuses existing helpers)
(function(){
  __LOG_INFO__ && AppLog.info('[AUTH] Lightweight nudge glue: start');
  try {
    const FIRST_KEY = 'auth:firstSeenAt';
    const LAST_NUDGE_KEY = 'auth:lastNudgeAt';
    const LAST_DISMISS_KEY = 'auth:lastDismissAt';

    function nowMs(){ return Date.now(); }

    function ensureFirstSeenAnchor(){
      try {
        if (window.currentSession || getStoredSession()) return; // have session; no need
      } catch(_) {}
      try {
        const has = (typeof getCacheItem === 'function') ? getCacheItem(FIRST_KEY) : null;
        if (!has) {
          if (typeof setCacheItem === 'function') {
            setCacheItem(FIRST_KEY, String(nowMs()), CACHE_EXPIRATION.PERSISTENT);
          }
        }
      } catch(_) {}
    }

    function minutesSince(ts){ try { return (nowMs() - Number(ts||0)) / 60000; } catch(_) { return 1e9; } }

    function shouldPromptNow(context){
      try {
        // Respect a cooldown after last dismiss or last shown
        const lastShown = (typeof getCacheItem === 'function') ? getCacheItem(LAST_NUDGE_KEY) : null;
        const lastDismiss = (typeof getCacheItem === 'function') ? getCacheItem(LAST_DISMISS_KEY) : null;
        const threshold = Number(getTimeThreshold() || 0);
        const coolMin = Math.max(1, threshold); // reuse threshold as cooldown
        if (lastDismiss && minutesSince(lastDismiss) < coolMin) return false;
        if (lastShown && minutesSince(lastShown) < coolMin) return false;

        // Anchor time: anonymous user creation or first seen
        let createdAt = null;
        try { createdAt = window.currentSession?.user?.created_at || null; } catch(_) {}
        if (!createdAt) {
          try { createdAt = (typeof getCacheItem === 'function') ? getCacheItem(FIRST_KEY) : null; } catch(_) {}
        }
        if (!createdAt) return false; // no anchor yet → don't prompt immediately

        const elapsed = getTimeSinceCreation(createdAt);
        return elapsed >= getTimeThreshold();
      } catch(_) { return false; }
    }

    function recordPromptShown(){ 
      try { 
        if (typeof setCacheItem === 'function') {
          setCacheItem(LAST_NUDGE_KEY, String(nowMs()), CACHE_EXPIRATION.ONE_WEEK);
        }
      } catch(_) {} 
    }
    function recordPromptDismissed(){ 
      try { 
        if (typeof setCacheItem === 'function') {
          setCacheItem(LAST_DISMISS_KEY, String(nowMs()), CACHE_EXPIRATION.ONE_WEEK);
        }
      } catch(_) {} 
    }

    async function promptSignInWithNudge(message, context){
      try {
        ensureFirstSeenAnchor();
        if (!shouldPromptNow(context)) return false;
        recordPromptShown();
        try { if (message) showMessage(message, true); } catch(_) {}
        try { window.AuthUI?.showAuthModal?.(); } catch(_) {}
        return true;
      } catch(_) { return false; }
    }

    window.AuthNudge = {
      ensureFirstSeenAnchor,
      shouldPromptNow,
      recordShown: recordPromptShown,
      recordDismissed: recordPromptDismissed,
      prompt: promptSignInWithNudge
    };
  } catch(_) {}
})();

// Display Messages
function showMessage(message, isError) {
    const messageEl = document.getElementById('message');
    if (messageEl) {
        messageEl.textContent = message;
        messageEl.classList.remove('d-none', 'error', 'success');
        messageEl.classList.add(isError ? 'error' : 'success');
    }
    
    if (window.AuthUI && window.AuthUI.showMessage) {
        window.AuthUI.showMessage(message, isError);
    }
}

// Session Management using storage-management.js functions
let currentSession = null;
window.currentSession = null;
let sessionRefreshInterval = null;

function startSessionRefreshTimer() {
    if (sessionRefreshInterval) clearInterval(sessionRefreshInterval);
    
    // Refresh session every 45 minutes to keep Supabase JWT alive (default expiry is 1 hour)
    const REFRESH_INTERVAL_MS = 45 * 60 * 1000;
    
    sessionRefreshInterval = setInterval(async () => {
        if (!window.currentSession) {
            clearInterval(sessionRefreshInterval);
            return;
        }
        
        __LOG_INFO__ && AppLog.info('[AUTH] Background session refresh starting...');
        try {
            const res = await AuthAPI.getSession();
            if (res && res.success && res.session) {
                __LOG_INFO__ && AppLog.info('[AUTH] Background session refresh successful');
                updateCurrentSession(res.session);
                updateUI(res.session);

                // Explicitly update WatchlistManager if it exists
                if (window.WatchlistManager && typeof window.WatchlistManager.updateUserState === 'function') {
                    window.WatchlistManager.updateUserState(res.session.user, res.session);
                }
                
                // Also notify VR WatchlistApp if it exists
                if (window.WatchlistApp && window.WatchlistApp.Manager && typeof window.WatchlistApp.Manager.updateWatchlistState === 'function') {
                    window.WatchlistApp.Manager.updateWatchlistState().then(({ userId, watchlists }) => {
                        if (userId && window.WatchlistApp.Manager.populateWatchlistDropdown) {
                            window.WatchlistApp.Manager.populateWatchlistDropdown(watchlists, userId, false);
                        }
                    }).catch(err => __LOG_WARN__ && AppLog.warn('[AUTH] Background WatchlistApp update failed:', err));
                }
            } else {
                __LOG_WARN__ && AppLog.warn('[AUTH] Background session refresh failed or returned no session', res);
            }
        } catch (e) {
            __LOG_ERROR__ && AppLog.error('[AUTH] Background session refresh error:', e.message);
        }
    }, REFRESH_INTERVAL_MS);
}

__LOG_INFO__ && AppLog.info('[AUTH] auth.js script starting');
// Session expiration time in minutes (24 hours = 1440 minutes)
const SESSION_STORAGE_KEY = 'auth_session';

function updateCurrentSession(session) {
    // During recovery, keep it in a private var.
    if (window._authRecoveryActive && session) {
        try { window._recoverySession = session; __LOG_INFO__ && AppLog.info('[AuthRecovery] Session during recovery stored privately'); } catch (_) {}
    }

    currentSession = session;
    window.currentSession = session;

    // Notify Watchlist managers
    if (window.WatchlistManager && typeof window.WatchlistManager.updateUserState === 'function') {
        window.WatchlistManager.updateUserState(session ? session.user : null, session);
    }
    if (window.WatchlistApp && window.WatchlistApp.Manager && typeof window.WatchlistApp.Manager.updateWatchlistState === 'function') {
        window.WatchlistApp.Manager.updateWatchlistState().then(({ userId, watchlists }) => {
            if (userId && window.WatchlistApp.Manager.populateWatchlistDropdown) {
                window.WatchlistApp.Manager.populateWatchlistDropdown(watchlists, userId, false);
            }
        }).catch(err => __LOG_WARN__ && AppLog.warn('[AUTH] WatchlistApp update failed:', err));
    }
    
    if (session) {
        // Ensure we're storing all the necessary session data
        const sessionData = {
            access_token: session.access_token,
            refresh_token: session.refresh_token,
            expires_at: session.expires_at,
            expires_in: session.expires_in,
            token_type: session.token_type,
            app_session: session.app_session === true,
            auth_provider: session.app_session === true ? 'app_session' : (session.auth_provider || session.authProvider || 'supabase'),
            user: session.user,
            device_id: session.device_id || window.currentSession?.device_id
        };
        if (__LOG_INFO__) dbg('updateCurrentSession.write', { uid: _uidTail(session?.user?.id), token: _maskToken(session?.access_token) });
        // Use storage-management's setCacheItem with configured TTL
        // Instead of aligning with the short-lived JWT expiry (e.g. 1 hour),
        // we use the full AUTH_SESSION_TTL_DAYS.
        // This ensures the session "hint" persists in localStorage so the AuthAPI 
        // can attempt a cookie-based recovery even after the JWT has expired.
        let ttlMinutes = 129600; // Default 90 days (90 * 24 * 60)
        try {
            // Priority: window.AUTH_CONFIG > Fallback (90)
            if (typeof window !== 'undefined' && window.AUTH_CONFIG && window.AUTH_CONFIG.AUTH_SESSION_TTL_DAYS) {
                ttlMinutes = Number(window.AUTH_CONFIG.AUTH_SESSION_TTL_DAYS) * 24 * 60;
            }
        } catch(_) {}
        
        try { setCacheItem(SESSION_STORAGE_KEY, sessionData, ttlMinutes); } catch(e) { if (__LOG_INFO__) dbg('updateCurrentSession.setCacheItem.error', { message: e?.message }); }
        // Clear explicit sign-out sentinel now that we have an active session again
        try { 
          if (typeof localStorage !== 'undefined') {
            localStorage.removeItem('ss_signed_out');
          }
        } catch(_) {}
        
        // Also maintain a plain localStorage mirror (non-sensitive hint only)
        try {
            const mirror = {
                hint: 1,
                expires_at: sessionData.expires_at || null,
                uid_tail: _uidTail(sessionData?.user?.id) || null
            };
            if (typeof localStorage !== 'undefined') {
              localStorage.setItem(SESSION_STORAGE_KEY + '_mirror', JSON.stringify(mirror));
            }
        } catch(e) { if (__LOG_INFO__) dbg('updateCurrentSession.mirror.error', { message: e?.message }); }

        // Protect the session key so it doesn't get cleaned up automatically
        try { protectKey(SESSION_STORAGE_KEY); } catch(e) { if (__LOG_INFO__) dbg('updateCurrentSession.protectKey.error', { message: e?.message }); }
        
        try { if (__LOG_INFO__) dbg('updateCurrentSession.verify', { sm_uid: _uidTail(getCacheItem(SESSION_STORAGE_KEY)?.user?.id) }); } catch(_) {}
    } else {
        // Remove session from storage
        if (__LOG_INFO__) dbg('updateCurrentSession.clear');
        try { 
          if (typeof localStorage !== 'undefined') {
            localStorage.removeItem(SESSION_STORAGE_KEY);
            localStorage.removeItem(SESSION_STORAGE_KEY + '_mirror');
          }
        } catch(e) { if (__LOG_INFO__) dbg('updateCurrentSession.clear.error', { message: e?.message }); }
    }
}

function getStoredSession() {
    try {
        // Use storage-management's getCacheItem
        const session = getCacheItem(SESSION_STORAGE_KEY);
        
        if (session) {
            // Additional check for token expiration (with 5 minute buffer)
            const now = Date.now() / 1000;
            const expiryBuffer = 300; // 5 minutes
            
            if (session.expires_at && now > (session.expires_at - expiryBuffer)) {
                if (__LOG_INFO__) dbg('getStoredSession.expired', { expires_at: session.expires_at, now });
                if (typeof localStorage !== 'undefined') {
                  localStorage.removeItem(SESSION_STORAGE_KEY);
                  localStorage.removeItem(SESSION_STORAGE_KEY + '_mirror');
                }
                return null;
            }
            
            return session;
        }
    } catch (error) {
        __LOG_ERROR__ && AppLog.error('[AUTH][ERROR] Error reading stored session', { error: error.message });
        if (typeof localStorage !== 'undefined') {
          localStorage.removeItem(SESSION_STORAGE_KEY);
        }
    }
    return null;
}

// Auth API Helper Functions
class AuthAPI {
    static _sessionPromise = null;

    static getStoredSession() {
        return getStoredSession();
    }

    static async makeRequest(endpoint, options = {}) {
        // Context-aware path resolution
        let path = endpoint.trim();
        if (!path.startsWith('/')) path = '/' + path;

        const isAuth = path.startsWith('/auth/') || path === '/auth';
        const isFB = path.startsWith('/api-fb/') || path === '/api-fb';

        if (!isAuth && !isFB) {
            path = '/auth' + path;
        }
        const url = path.startsWith('/api-fb/') ? path : `/api${path}`;
        const pathLower = path.toLowerCase();

        // CRITICAL DEBUG: Trace every outgoing auth request
        try {
            __LOG_INFO__ && AppLog.info(`[Auth][client] makeRequest starting: ${endpoint}`, {
                method: options.method || 'GET',
                hasBody: !!options.body,
                currentSession: !!window.currentSession,
                recoverySession: !!window._recoverySession,
                storedSession: !!getStoredSession()
            });
        } catch(_) {}

        const defaultOptions = {
            headers: {
                'Content-Type': 'application/json'
            },
            credentials: 'include' // ensure cookies (e.g., ss_bearer) are sent on same-origin requests
        };
        // Add authorization header if we have a session, unless we intentionally prefer cookie auth
        const noAuth = options && options.noAuth === true; // allow callers to force cookie-only requests
        const skipAuthHeader = (!noAuth) ? (pathLower === '/auth/session' && window._preferCookieAuth === true) : true;
        let accessToken = null;
        if (!skipAuthHeader && !noAuth) {
            accessToken = window._recoverySession?.access_token || window.currentSession?.access_token;
            // If no current session, try to get from stored session
            if (!accessToken) {
                const storedSession = getStoredSession();
                if (storedSession?.access_token) {
                    updateCurrentSession(storedSession);
                    accessToken = storedSession.access_token;
                }
            }
            if (accessToken) {
                defaultOptions.headers.Authorization = `Bearer ${accessToken}`;
            }
        }
        // Attach a stable device key so the server can link this device on authenticated calls
        try {
            let deviceKey = null;
            try {
                deviceKey = (typeof getCacheItem === 'function') ? getCacheItem('ss_device_key') : null;
            } catch(_) {}
            if (!deviceKey) {
                deviceKey = (typeof crypto !== 'undefined' && crypto.randomUUID) ? crypto.randomUUID() : (Math.random().toString(36).slice(2) + Date.now().toString(36));
                try {
                    if (typeof setCacheItem === 'function') {
                        setCacheItem('ss_device_key', deviceKey, 365 * 24 * 60);
                    } else {
                        localStorage.setItem('ss_device_key', deviceKey);
                    }
                    if (typeof protectKey === 'function') protectKey('ss_device_key');
                } catch(_) {}
            }
            if (deviceKey) defaultOptions.headers['x-device-key'] = deviceKey;
        } catch(_) {}

        // Add site passcode header if available to satisfy protected non-admin routes.
        try {
            const cookies = document.cookie.split(';').reduce((acc, c) => {
                const [k, v] = c.split('=').map(s => s.trim());
                if (k) acc[k] = v;
                return acc;
            }, {});
            const pc = cookies['passcode'];
            if (pc) defaultOptions.headers['x-passcode'] = pc;
        } catch(_) {}

        const mergedHeaders = { ...defaultOptions.headers, ...options.headers };
        // Ensure Authorization is fresh if we just updated currentSession
        if (accessToken && !noAuth) {
            mergedHeaders.Authorization = `Bearer ${accessToken}`;
        }

        const response = await fetch(url, {
            ...defaultOptions,
            ...options,
            headers: mergedHeaders
        });
        let data = null;
        try {
            data = await response.json();
        } catch(_) {
            data = {};
        }
        // Special-case handling for benign 401s
        if (!response.ok) {
            // CRITICAL DEBUG: Log detailed failure for ANY non-OK response
            try {
                __LOG_WARN__ && AppLog.warn(`[Auth][client] makeRequest FAILED: ${endpoint}`, {
                    status: response.status,
                    statusText: response.statusText,
                    url: response.url
                });
            } catch(_) {}
            
            // Handle 401 Unauthorized: Attempt one-time background refresh unless it's the session/signout endpoint itself
            if (response.status === 401 && !options._retry && !pathLower.includes('/session') && !pathLower.includes('/signout')) {
                __LOG_INFO__ && AppLog.info(`[Auth][client] Attempting session refresh after 401 for ${endpoint}`);
                try {
                    const refreshRes = await this.getSession();
                    if (refreshRes && refreshRes.success) {
                        // Retry the original request with the fresh session
                        return await this.makeRequest(endpoint, { ...options, _retry: true });
                    }
                } catch (refreshErr) {
                    __LOG_WARN__ && AppLog.warn(`[Auth][client] Session refresh failed during 401 retry for ${endpoint}:`, refreshErr);
                }
            }

            if (response.status === 401) {
                // Treat "/session" 401 as logged-out (benign)
                if (pathLower.includes('/session')) {
                    return { success: false, session: null, status: 401 };
                }
                // Treat "/signout" 401 as success (idempotent local sign-out)
                if (pathLower.includes('/signout')) {
                    return { success: true, status: 401 };
                }
            }
            // For all other endpoints/statuses, log and throw as before.
            const errorPayload = {
                status: response.status,
                error: data && data.error,
                // Add response headers for debugging
                responseHeaders: Object.fromEntries(response.headers.entries())
            };
            __LOG_ERROR__ && AppLog.error(`[Auth][client] Request failed to ${endpoint}`, errorPayload);
            throw new Error((data && data.error) || `HTTP ${response.status}`);
        }
        return data;
    }

    static async createAnonymousUser() {
        return await this.makeRequest('/create-anonymous', {
            method: 'POST'
        });
    }

    static async createAccount(email, password) {
        const redirect_to = (typeof window.getAuthReturnUrl === 'function') ? window.getAuthReturnUrl(true) : window.location.href;
        return await this.makeRequest('/create-account', {
            method: 'POST',
            body: JSON.stringify({ email, password, redirect_to })
        });
    }

    static async signIn(email, password) {
        const res = await this.makeRequest('/signin', {
            method: 'POST',
            body: JSON.stringify({ email, password })
        });
        try {
            if (res && res.success && res.session) {
                if (res.device_id) res.session.device_id = res.device_id;
                
                if (res.session.user && res.session.user.is_anonymous !== true) {
                    const ttlMinutes = CACHE_EXPIRATION.ONE_YEAR;
                    try { setCacheItem('ss_device_bound', '1', ttlMinutes); } catch(_) {}
                    try { protectKey && protectKey('ss_device_bound'); } catch(_) {}
                    if (__LOG_INFO__) dbg('device.bound.set', { key: 'ss_device_bound', via: 'signIn' });
                }
            }
        } catch(_) {}
        return res;
    }

    // In the upgradeAnonymous function, update to handle new session:
    static async upgradeAnonymous(email, password, accessToken) {
        const redirect_to = (typeof window.getAuthReturnUrl === 'function') ? window.getAuthReturnUrl(true) : window.location.href;
        // Log the exact redirect_to value being sent for debugging
        try { __LOG_INFO__ && AppLog.info('[AuthRedirect][client] upgradeAnonymous()', { redirect_to, from: window.location.href }); } catch (_) {}
        const result = await this.makeRequest('/upgrade-anonymous', {
            method: 'POST',
            body: JSON.stringify({
                email: email,
                password: password,
                access_token: accessToken,
                redirect_to: redirect_to
            })
        });

        // ✅ Update current session with new token if provided
        if (result.success && result.session) {
            updateCurrentSession(result.session);
        }

        return result;
    }

    static async resetPassword(email) {
        const redirect_to = (typeof window.getAuthReturnUrl === 'function') ? window.getAuthReturnUrl(false, true) : window.location.href;
        return await this.makeRequest('/reset-password-request', {
            method: 'POST',
            body: JSON.stringify({ email, redirect_to })
        });
    }

    static async updatePassword(newPassword) {
        // Use recovery session if present, else fallback to current/stored
        const session = window._recoverySession || window.currentSession || getStoredSession();
        const token = session?.access_token;
        const options = {
            method: 'POST',
            body: JSON.stringify({ password: newPassword })
        };
        // Explicitly pass the recovery token in header if we found one
        if (token) {
            options.headers = { 'Authorization': `Bearer ${token}` };
        }
        return await this.makeRequest('/update-password', options);
    }

    static async getSession() {
        // Prevent concurrent session probes/refreshes
        if (this._sessionPromise) {
            try { if (__LOG_INFO__) dbg('getSession.waiting', { reason: 'already_in_progress' }); } catch(_) {}
            return await this._sessionPromise;
        }

        this._sessionPromise = (async () => {
            try {
                // Debug: entry and local evidence snapshot (non-sensitive)
                try {
                    const hasCurrent = !!(window && window.currentSession && window.currentSession.access_token);
                    let storedForLog = null;
                    try { storedForLog = (typeof getStoredSession === 'function') ? getStoredSession() : null; } catch(_) {}
                    try { if (__LOG_INFO__) dbg('getSession.enter', { hasCurrent, hasStored: !!(storedForLog && storedForLog.access_token), preferCookieAuth: !!window._preferCookieAuth }); } catch(_) {}
                } catch(_) {}

                // Special handling: if we have tokens in the URL hash, try to exchange them first
                if (!window._sbAuthBridgeAttached) {
                    try {
                        const u = new URL(window.location.href);
                        const hash = u.hash || '';
                        if (hash.includes('access_token=')) {
                            if (__LOG_INFO__) dbg('getSession.detectedHash', { hash: hash.substring(0, 50) + '...' });
                            // Trigger the bridge immediately
                            ensureSupabaseAuthBridge();
                        }
                    } catch (_) {}
                }

                // Short-circuit when there is no local session evidence. The browser cannot read the
                // HttpOnly refresh cookie, so the readable device-bound hint is valid evidence that
                // the server may still be able to refresh the session.
                try {
                    const stored = (typeof getStoredSession === 'function') ? getStoredSession() : null;
                    const signedOut = (typeof getCacheItem === 'function') ? getCacheItem('ss_signed_out') : null;
                    const boundFlag = (function(){
                        try {
                            const sm = (typeof getCacheItem === 'function') ? getCacheItem('ss_device_bound') : null;
                            if (sm === true || sm === '1') return true;
                            const cookieMatch = document.cookie.match(/(^| )ss_device_bound=([^;]+)/);
                            return !!(cookieMatch && cookieMatch[2] === '1');
                        } catch(_) { return false; }
                    })();
                    const hasAppSession = !!(window.currentSession && window.currentSession.app_session) || !!(stored && stored.app_session);
                    if (signedOut && !window.currentSession && !stored && !boundFlag) {
                        try { if (__LOG_INFO__) dbg('getSession.skip', { reason: 'signed_out', boundFlag }); } catch(_) {}
                        return { success: false, session: null, status: 0, reason: 'signed_out' };
                    }
                    if ((!stored || (!stored.access_token && !stored.app_session)) && !boundFlag && !hasAppSession && !window._preferCookieAuth) {
                        try { if (__LOG_INFO__) dbg('getSession.skip', { reason: 'no_local_session', boundFlag }); } catch(_) {}
                        // No local session evidence → do not call server
                        return { success: false, session: null, status: 0, reason: 'no_local_session' };
                    }
                } catch(_) {}

        // Call server to validate/refresh the session (cookie or bearer depending on makeRequest policy)
        try { if (__LOG_INFO__) dbg('getSession.call', { endpoint: '/session', preferCookieAuth: !!window._preferCookieAuth }); } catch(_) {}
        try {
            const options = {
                method: 'GET',
                headers: {}
            };

            let res = await this.makeRequest('/session', options);
                    
                    // ✅ One-time retry for /session 401 if we have evidence of a prior session.
                    // This handles race conditions in multi-container environments where a concurrent 
                    // request might have just rotated the refresh token and set new cookies.
                    if (res && res.status === 401 && !window._preferCookieAuth && (window.currentSession || getStoredSession())) {
                        try { if (__LOG_INFO__) dbg('getSession.retry', { reason: 'stale_token_race' }); } catch(_) {}
                        await new Promise(r => setTimeout(r, 200)); // wait for cookies to settle
                        // Retry with preferCookieAuth = true to rely on the potentially new cookies
                        const originalPrefer = window._preferCookieAuth;
                        try {
                            window._preferCookieAuth = true;
                            res = await this.makeRequest('/session', options);
                        } finally {
                            window._preferCookieAuth = originalPrefer;
                        }
                    }

                    if (res && res.success && res.session) {
                        if (res.device_id) res.session.device_id = res.device_id;
                        updateCurrentSession(res.session);
                    } else if (res && res.status === 401) {
                        // Terminal 401 for session itself → existing session is dead, clear it to avoid loops
                        try { if (__LOG_INFO__) dbg('getSession.terminal401', { action: 'clear_session' }); } catch(_) {}
                        updateCurrentSession(null);
                    }
                    try { if (__LOG_INFO__) dbg('getSession.response', { ok: !!res?.success, status: res?.status, uid: _uidTail(res?.session?.user?.id), consent: res?.consent?.granted, survey_applied: !!res?.survey_applied }); } catch(_) {}
                    return res;
                } catch (e) {
                    try { if (__LOG_INFO__) dbg('getSession.error', { message: e?.message }); } catch(_) {}
                    throw e; // preserve existing behavior
                }
            } finally {
                this._sessionPromise = null;
            }
        })();

        return await this._sessionPromise;
    }

    // Adopt a provided session (e.g., from device-link redeem) without altering existing endpoints
    static async adoptSession(session) {
        try {
            // Do NOT sign out first; avoid clearing cookies or racing guest creation.
        } catch (_) {}
        try {
            // Ensure recovery mode is disabled so we persist the new session
            try { window._authRecoveryActive = false; } catch(_) {}

            // Persist provisional session from redeem immediately
            if (__LOG_INFO__) dbg('adoptSession.persist', { uid: _uidTail(session?.user?.id), token: _maskToken(session?.access_token) });
            updateCurrentSession(session);
            if (__LOG_INFO__) dbg('adoptSession.afterPersist', { storedUid: _uidTail(getCacheItem('auth_session')?.user?.id) });

            // Optionally fetch authoritative session from backend using COOKIE (avoid sending any stale bearer)
            let finalSession = session;
            try {
                window._preferCookieAuth = true; // instruct makeRequest to skip Authorization header for /session
                const data = await this.getSession();
                if (__LOG_INFO__) dbg('adoptSession.serverSession', { ok: !!data?.success, uid: _uidTail(data?.session?.user?.id) });
                if (data && data.success && data.session && data.session.user && data.session.user.id) {
                    // Only overwrite if server session matches the redeemed user (avoid anonymous overwrite)
                    if (!session.user || String(data.session.user.id) === String(session.user.id)) {
                        finalSession = data.session;
                        updateCurrentSession(finalSession);
                        if (__LOG_INFO__) dbg('adoptSession.persistServer', { storedUid: _uidTail(getCacheItem('auth_session')?.user?.id) });
                    } else {
                        if (__LOG_INFO__) dbg('adoptSession.mismatch', { redeemed: _uidTail(session?.user?.id), server: _uidTail(data.session.user.id) });
                    }
                }
            } catch(e) { if (__LOG_INFO__) dbg('adoptSession.getSession.error', { message: e?.message }); } finally { try { window._preferCookieAuth = false; } catch(_) {} }

            // Mark this device as bound to a registered account so we do not auto-create a guest on future loads
            try {
                const ttlMinutes = CACHE_EXPIRATION.ONE_YEAR;
                try { setCacheItem('ss_device_bound', '1', ttlMinutes); } catch(_) {}
                try { protectKey && protectKey('ss_device_bound'); } catch(_) {}
                if (__LOG_INFO__) dbg('device.bound.set', { key: 'ss_device_bound' });
            } catch(_) {}

            // Update UI and notify listeners
            try { if (typeof updateUI === 'function') updateUI(finalSession); } catch (e) { if (__LOG_INFO__) dbg('adoptSession.updateUI.error', { message: e?.message }); }
            try { document.dispatchEvent(new CustomEvent('auth:session-changed', { detail: { session: finalSession } })); } catch (e) { if (__LOG_INFO__) dbg('adoptSession.dispatch.error', { message: e?.message }); }
            return { success: true };
        } catch (e) {
            __LOG_ERROR__ && AppLog.error('[AUTH][ERROR] adoptSession failed', { error: e.message });
            if (__LOG_INFO__) dbg('adoptSession.error', { message: e?.message });
            return { success: false, error: e.message };
        }
    }

    static async signOut(opts = {}) {
        // Default to local-only signout unless explicitly requested as global
        const doGlobal = opts && Object.prototype.hasOwnProperty.call(opts, 'global') ? !!opts.global : false;
        // Start a short suppression window to avoid immediate /session re-queries/races
        try { window._suppressSessionFetchUntil = Date.now() + 2000; } catch(_) {}

        // Mark this device as explicitly signed-out to block auto re-adoption
        try {
            if (typeof setCacheItem === 'function') {
                setCacheItem('ss_signed_out', String(Date.now()), CACHE_EXPIRATION.ONE_DAY);
            }
        } catch(_) {}

        // 2) Clear server cookie/session for this device
        // If global, use /signout-all (requires authentication)
        const endpoint = doGlobal ? '/signout-all' : '/signout';
        const res = await this.makeRequest(endpoint, {
            method: 'POST',
            noAuth: !doGlobal // local signout uses cookie only; global requires bearer
        });

        try {
            // Clear any stored session and update UI immediately
            updateCurrentSession(null);
            try { if (window.AuthUI && typeof window.AuthUI.updateUI === 'function') { window.AuthUI.updateUI(null); } } catch(_) {}
            try { document.dispatchEvent(new CustomEvent('auth:session-changed', { detail: { session: null } })); } catch(_) {}
        } catch(_) {}
        return res;
    }

    static async updateProfile(profileData) {
        // Use POST /auth/update-profile (authenticated)
        return await this.makeRequest('/update-profile', {
            method: 'POST',
            body: JSON.stringify(profileData)
        });
    }

    static async deleteAccount() {
        return await this.makeRequest('/delete-account', {
            method: 'DELETE'
        });
    }
}

// Initialize user session (create anonymous if needed)
async function initializeUserOnce() {
    __LOG_INFO__ && AppLog.info('[AUTH] initializeUserOnce: start', { consentGiven, userInitialized: window.userInitialized });
    if (!consentGiven) {
        return;
    }

    if (window.userInitialized) {
        return;
    }

    try {
        // 0) Preflight: no Supabase client needed here; session is already in currentSession or store
        const signedOut = (typeof getCacheItem === 'function') ? getCacheItem('ss_signed_out') : null;
        if (!signedOut) {
            const stored = getStoredSession();
            if (stored) {
                updateCurrentSession(stored);
                updateUI(stored);
                window.userInitialized = true;
                startSessionRefreshTimer();
                return;
            }
        }

        // 1) Check if we have a stored session
        const storedSession = signedOut ? null : getStoredSession();
        if (storedSession) {
            // Update current session with stored data
            updateCurrentSession(storedSession);
            
            try {
            // Verify the stored session is still valid with server
            const sessionData = await AuthAPI.getSession();
            if (sessionData.success && sessionData.session) {
                // Update with fresh session data from server
                updateCurrentSession(sessionData.session);
                updateUI(sessionData.session);
                window.userInitialized = true;
                startSessionRefreshTimer();
                return;
            }
            } catch (error) {
                updateCurrentSession(null);
            }
        }

        // 2) Try to fetch a server-backed session (cookie-based) only when there is evidence of auth
        try {
            const suppress = (typeof window !== 'undefined') && window._suppressSessionFetchUntil && Date.now() < window._suppressSessionFetchUntil;
            const boundFlag = (function(){ 
                try { 
                    const sm = (typeof getCacheItem === 'function') ? getCacheItem('ss_device_bound') : null; 
                    if (sm === true || sm === '1') return true;
                    const cookieMatch = document.cookie.match(/(^| )ss_device_bound=([^;]+)/);
                    return !!(cookieMatch && cookieMatch[2] === '1');
                } catch(_) { return false; } 
            })();
            const hasEvidence = !signedOut && (!!(window.currentSession) || !!getStoredSession() || boundFlag);
            const allowCookieProbe = (typeof window !== 'undefined') && window._preferCookieAuth === true;
            if (!suppress && (hasEvidence || allowCookieProbe)) {
                const serverSession = await AuthAPI.getSession();
                if (serverSession && serverSession.success && serverSession.session) {
                    updateCurrentSession(serverSession.session);
                    updateUI(serverSession.session);
                    window.userInitialized = true;
                    startSessionRefreshTimer();
                    return;
                }
            }
        } catch(_) {}

        // 2.5) If this device is bound to a registered account, do NOT auto-create a guest. Prompt for sign-in instead.
        try {
            const boundFlag = (function(){
                try {
                    const sm = (typeof getCacheItem === 'function') ? getCacheItem('ss_device_bound') : null;
                    if (sm === true || sm === '1') return true;
                    const cookieMatch = document.cookie.match(/(^| )ss_device_bound=([^;]+)/);
                    return !!(cookieMatch && cookieMatch[2] === '1');
                } catch(_) { return false; }
            })();
            if (boundFlag) {
                // Allow one-time override to continue as guest if explicitly requested
                if (window.__FORCE_GUEST_ONCE === true) {
                    try { window.__FORCE_GUEST_ONCE = false; } catch(_) {}
                } else {
                    // Nudge-gated prompt instead of immediate modal
                    try { window.AuthNudge?.prompt('Please sign in to continue', 'device_bound'); } catch(_) {}
                    return;
                }
            }
        } catch(_) {}

        // 3) No valid session exists - optionally create anonymous user
        //    but suppress this briefly after device-link adoption to avoid race conditions
        try {
            let suppressUntil = null;
            try {
                if (typeof getCacheItem === 'function') {
                    suppressUntil = getCacheItem('ss_suppress_anon_until');
                }
            } catch(_) {}
            
            const cachedAnonDisabled = (function(){ 
              try { 
                return ((typeof getCacheItem === 'function') ? getCacheItem('auth:anonDisabled') : null) === '1'; 
              } catch(_) { return false; } 
            })();
            
            const anonDisabled = (window.AUTH_DISABLE_ANONYMOUS === true) || (window.ANONYMOUS_DISABLED === true) || cachedAnonDisabled;
            
            const suppressionActive = anonDisabled || (window.preventAnonymousCreation === true) || (suppressUntil && Date.now() < Number(suppressUntil));

            if (__LOG_INFO__) dbg('ANON_CHECK', {
                anonDisabled,
                suppressionActive,
                window_AUTH_DISABLE_ANONYMOUS: window.AUTH_DISABLE_ANONYMOUS,
                window_ANONYMOUS_DISABLED: window.ANONYMOUS_DISABLED,
                cachedAnonDisabled,
                window_preventAnonymousCreation: window.preventAnonymousCreation,
                suppressUntil: suppressUntil ? new Date(Number(suppressUntil)).toISOString() : null,
                now: new Date().toISOString()
            });

            if (suppressionActive) {
                if (__LOG_INFO__) dbg('ANON_SUPPRESSED', { reason: anonDisabled ? 'disabled' : 'active' });
                // If anonymous is disabled, prompt for sign-in using nudge cadence
                if (anonDisabled) {
                    try { window.AuthNudge?.prompt('Guest access is disabled. Please sign in to continue.', 'anon_disabled_suppress'); } catch(_) {}
                } else {
                    // Otherwise, try again shortly; this allows the adopted session to stabilize via /api/auth/session
                    setTimeout(() => { try { initializeUserOnce(); } catch(_) {} }, 1000);
                }
                return;
            }
        } catch(_) {}

        if (!window.creatingAnonymousUser) {
            if (__LOG_INFO__) dbg('ANON_CREATE', { msg: 'Attempting to create anonymous user' });
            window.creatingAnonymousUser = true;

            try {
                const result = await AuthAPI.makeRequest('/create-anonymous', {
                    method: 'POST'
                });
                if (result.success) {
                    updateCurrentSession(result.session);
                    showMessage('Welcome! You are browsing as a guest.', false);
                    updateUI(result.session);
                    window.userInitialized = true;
                }
            } catch (error) {
                const msg = String(error && error.message || '').toLowerCase();
                if (msg.includes('anonymous sign-ins are disabled') || msg.includes('anonymous signins are disabled') || msg.includes('anon') && msg.includes('disabled')) {
                    try { 
                      window.ANONYMOUS_DISABLED = true; 
                      if (typeof setCacheItem === 'function') {
                        setCacheItem('auth:anonDisabled','1', CACHE_EXPIRATION.ONE_DAY);
                      }
                    } catch(_) {}
                    try { window.preventAnonymousCreation = true; } catch(_) {}
                    // Nudge-gated login prompt
                    try { window.AuthNudge?.prompt('Guest access is disabled. Please sign in to continue.', 'anon_disabled_error'); } catch(_) {}
                } else {
                    __LOG_ERROR__ && AppLog.error('[AUTH][ERROR] Failed to create anonymous user', { error: error.message });
                    showMessage('Guest access unavailable. Please try refreshing.', true);
                }
            } finally {
                window.creatingAnonymousUser = false;
            }
        }
    } catch (error) {
        __LOG_ERROR__ && AppLog.error('[AUTH][ERROR] User initialization failed', { error: error.message });
        showMessage('Authentication setup failed', true);
    }
}

// GDPR Cookie Consent with Categories
let consentInitialized = false;
let consentGiven = false;
window.consentGiven = false; // Expose globally for AuthUI

// Consent persistence helpers
async function saveConsent(consentType, granted, attempt = 1) {
    try {
        const session = (window.currentSession || null);
        const token = session && session.access_token ? session.access_token : null;
        const hasAppSession = !!(session && session.app_session);
        if (!token && !hasAppSession) {
            if (attempt <= 5) {
                setTimeout(() => saveConsent(consentType, granted, attempt + 1), attempt * 500);
            }
            return;
        }
        const metadata = {
            ua: navigator.userAgent,
            page: location.pathname,
            tz: Intl.DateTimeFormat().resolvedOptions().timeZone || null,
        };
        await fetch('/api/auth/consents', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...(token ? { 'Authorization': `Bearer ${token}` } : {})
            },
            credentials: 'include',
            body: JSON.stringify({
                consent_type: consentType,
                granted: !!granted,
                version: 'cookies_v1',
                metadata
            })
        }).catch(() => {});
    } catch (_) { /* non-blocking */ }
}

// Initialize cookie consent
function initializeCookieConsent() {
    if (consentInitialized || typeof window.cookieconsent === 'undefined') {
        if (!consentInitialized) {
            setTimeout(initializeCookieConsent, 200);
        }
        return;
    }
    consentInitialized = true;

    try {
        const isAuthTestPage = window.location.pathname.includes('authtest.html');
        __LOG_INFO__ && AppLog.info('[AUTH][CONSENT] initializeCookieConsent starting...', { isAuthTestPage, pathname: window.location.pathname });
        
        // Check if standard cookieconsent library is present
        if (typeof window.cookieconsent === 'undefined') {
            __LOG_ERROR__ && AppLog.error('[AUTH][CONSENT] window.cookieconsent is UNDEFINED');
            return;
        }

        const config = {
            'palette': {
                'popup': {
                    'background': '#1e1e1e',
                    'text': '#ffffff'
                },
                'button': {
                    'background': '#28a745',
                    'text': '#ffffff'
                }
            },
            'theme': 'block',
            'position': 'bottom-right',
            'static': false,
            'type': 'opt-in',
            'content': {
                'message': 'This website uses cookies for authentication and to save your preferences. Please choose your preference.',
                'dismiss': 'Accept All Cookies',
                'deny': 'Decline',
                'link': 'Learn More',
                'href': '/privacy.html',
                'allow': 'Accept',
                'policy': 'Privacy Policy'
            },
            'law': {
                'regionalLaw': false,
            },
            'location': false,
            'onInitialise': function (status) {
                __LOG_INFO__ && AppLog.info('[AUTH][CONSENT] onInitialise:', status);
                consentGiven = (status === 'allow' || status === 'dismiss');
                window.consentGiven = consentGiven;
                updateButtonState();
                if (consentGiven) {
                    initializeAuthIfNeeded();
                }
            },
            'onStatusChange': function(status, chosenBefore) {
                __LOG_INFO__ && AppLog.info('[AUTH][CONSENT] onStatusChange:', status, { chosenBefore });
                consentGiven = (status === 'allow' || status === 'dismiss');
                window.consentGiven = consentGiven;
                if (consentGiven) {
                    initializeAuthIfNeeded();
                } else {
                    updateButtonState();
                }
            },
            'onPopupOpen': function() {
            },
            'onPopupClose': function() {
            }
        };

        if (isAuthTestPage) {
            config.revokable = true;
            config.animateRevokable = true;
            // Ensure it's not hidden by default if consent exists
            config.revokeBtn = '<div class="cc-revoke {{classes}}">Cookie Policy</div>';
        }

        window.cookieconsent.initialise(config, function(popup) {
            __LOG_INFO__ && AppLog.info('[AUTH][CONSENT] initialise callback', { status: popup.getStatus() });
            updateButtonState();
            window.cookieConsentInstance = popup;
        });
    } catch (error) {
        __LOG_ERROR__ && AppLog.error('[AUTH][CONSENT] initialization ERROR:', error);
        __LOG_ERROR__ && AppLog.error('[AUTH][ERROR] Cookie consent initialization failed', { error: error.message });
        showMessage('Cookie consent setup failed. Essential functionality may be limited.', true);
        updateButtonState();
    }
}

// Initialize Auth only after consent
function initializeAuthIfNeeded() {
    __LOG_INFO__ && AppLog.info('[AUTH] initializeAuthIfNeeded: consentGiven=', consentGiven);
    if (!consentGiven) {
        updateButtonState();
        return;
    }

    // Early detect recovery intent to avoid creating a guest session
    function isRecoveryUrl() {
        try {
            const u = new URL(window.location.href);
            const hash = u.hash || '';
            const sp = u.searchParams;
            const hasTypeRecoveryInHash = /(^|[&#?])type=recovery(?![\w-])/i.test(hash);
            const hasRecoveryInQuery = /recovery/i.test(sp.get('type') || '');
            let hasPwresetMarker = (sp.get('pwreset') === '1');
            
            // Also check sessionStorage for the marker
            if (!hasPwresetMarker) {
                try {
                    hasPwresetMarker = sessionStorage.getItem('auth:pendingPasswordRecovery') === 'true';
                } catch (_) {}
            }
            const hasOtpExpiredHash = /(^|[&#?])error_code=otp_expired(?![\w-])/i.test(hash) || /(^|[&#?])error=access_denied(?![\w-])/i.test(hash);
            const hasOtpExpiredQuery = /otp_expired/i.test(sp.get('error_code') || '') || /access_denied/i.test(sp.get('error') || '');
            return hasTypeRecoveryInHash || hasRecoveryInQuery || hasPwresetMarker || hasOtpExpiredHash || hasOtpExpiredQuery;
        } catch (_) { return false; }
    }

    if (isRecoveryUrl()) {
        window._authRecoveryActive = true;
        try { sessionStorage.setItem('auth:pendingPasswordRecovery', 'true'); __LOG_INFO__ && AppLog.info('[AuthRecovery] Detected recovery intent from URL; flagged pendingPasswordRecovery'); } catch (_) {}
    }

    updateButtonState();
    // Bootstrap Supabase auth session bridge first to capture post-OAuth session
    ensureSupabaseAuthBridge();

            // If in recovery flow, delay/skip anonymous creation until session is adopted
    if (window._authRecoveryActive) {
        // Poll briefly for a valid session to arrive in window.currentSession or window._recoverySession
        let attempts = 0;
        const maxAttempts = 60; // ~3s at 50ms each
        const timer = setInterval(async () => {
            attempts++;
            const session = window.currentSession || window._recoverySession;
            if (session) {
                clearInterval(timer);
                updateUI(session);
            }
            if (attempts >= maxAttempts) {
                clearInterval(timer);
            }
        }, 50);
        return; // Skip initializeUserOnce for now
    }

    // Then proceed with normal user initialization (may create anonymous if needed)
    initializeUserOnce();
}

// Update button state using AuthUI
function updateButtonState() {
    if (window.AuthUI) {
        window.AuthUI.updateButtonState(consentGiven, consentGiven);
    }
}

// Bootstrap Supabase auth session on page load/return and subscribe to changes
function ensureSupabaseAuthBridge() {
    if (window._sbAuthBridgeAttached) return;

    function cleanOAuthParams() {
        try {
            const url = new URL(window.location.href);
            const p = url.searchParams;
            // Clean OAuth/Recovery params from URL to keep address bar tidy
            const keepEmailConfirm = p.get('email-confirmation');
            const keysToRemove = ['code', 'state', 'provider', 'token_type', 'error', 'error_code', 'error_description', 'pwreset', 'type', 'email-confirmation'];
            let changed = false;
            
            // If we have flags in the URL, move them to sessionStorage before removing if they aren't already there
            if (keepEmailConfirm) {
                try { if (!sessionStorage.getItem('auth:email_confirmation')) sessionStorage.setItem('auth:email_confirmation', keepEmailConfirm); } catch(_) {}
            }
            if (p.get('pwreset') === '1' || p.get('type') === 'recovery') {
                try { if (!sessionStorage.getItem('auth:pendingPasswordRecovery')) sessionStorage.setItem('auth:pendingPasswordRecovery', 'true'); } catch(_) {}
            }

            keysToRemove.forEach((k) => { if (p.has(k)) { p.delete(k); changed = true; } });
            
            // Also clean hash
            if (url.hash && (url.hash.includes('access_token=') || url.hash.includes('error='))) {
                url.hash = '';
                changed = true;
            }

            if (changed) {
                history.replaceState({}, '', url.toString());
            }
        } catch (_) {}
    }

    async function handleManualHashExchange() {
        try {
            const hash = window.location.hash || '';
            if (!hash.includes('access_token=')) return false;

            window._sbAuthBridgeAttached = true;
            __LOG_INFO__ && AppLog.info('[AuthBridge] Manual hash exchange started');

            const params = new URLSearchParams(hash.substring(1));
            const access_token = params.get('access_token');
            const refresh_token = params.get('refresh_token');
            const type = params.get('type');

            if (access_token) {
                // If it's a recovery flow, ensure the flag is set before calling updateCurrentSession
                if (type === 'recovery') {
                    window._authRecoveryActive = true;
                    try { sessionStorage.setItem('auth:pendingPasswordRecovery', 'true'); } catch(_) {}
                }

                const res = await AuthAPI.makeRequest('/session-from-token', {
                    method: 'POST',
                    body: JSON.stringify({ access_token, refresh_token })
                });

            if (res && res.success && res.session) {
                if (res.device_id) res.session.device_id = res.device_id;
                __LOG_INFO__ && AppLog.info('[AuthBridge] Manual hash exchange success', { type, has_access_token: !!res.session.access_token });
                
                // If it IS recovery, we ensure the UI is alerted immediately
                if (type === 'recovery' || window._authRecoveryActive) {
                    window._recoverySession = res.session;
                    __LOG_INFO__ && AppLog.info('[AuthRecovery] Recovery session adoption starting...');
                    if (window.AuthUI) {
                        window.AuthUI.updateUI(res.session);
                        window.AuthUI.showResetUpdateModal();
                    }
                }

                // If this was an OAuth login (not recovery), make sure we clear any recovery flags
                if (type !== 'recovery') {
                    window._authRecoveryActive = false;
                    try { sessionStorage.removeItem('auth:pendingPasswordRecovery'); } catch(_) {}
                }

                updateCurrentSession(res.session);
                updateUI(res.session);
                cleanOAuthParams();
                startSessionRefreshTimer();
                return true;
            }
            }
        } catch (e) {
            __LOG_ERROR__ && AppLog.error('[AuthBridge] Manual hash exchange failed:', e.message);
        }
        return false;
    }

    function onReady(client) {
        if (window._sbAuthBridgeAttached) return;
        window._sbAuthBridgeAttached = true;

        function detectRecoveryFromUrl() {
            try {
                const href = window.location.href;
                const url = new URL(href);
                const hash = url.hash || '';
                const qp = url.searchParams;
                const inHash = /(^|[&#?])type=recovery(?![\w-])/i.test(hash) || /(^|[&#?])access_token=/i.test(hash);
                const inQuery = /recovery/i.test(qp.get('type') || '');
                let hasPwresetMarker = (qp.get('pwreset') === '1');
            
                // Also check sessionStorage for the marker
                if (!hasPwresetMarker) {
                    try {
                        hasPwresetMarker = sessionStorage.getItem('auth:pendingPasswordRecovery') === 'true';
                    } catch (_) {}
                }
                const otpExpired = /(^|[&#?])error_code=otp_expired(?![\w-])/i.test(hash) || /(^|[&#?])error=access_denied(?![\w-])/i.test(hash)
                    || /otp_expired/i.test(qp.get('error_code') || '') || /access_denied/i.test(qp.get('error') || '');

                if (otpExpired) {
                    // Show a friendly modal explaining the link has expired/been used
                    try {
                        // Clear any recovery flags
                        window._authRecoveryActive = false;
                        try { sessionStorage.removeItem('auth:pendingPasswordRecovery'); } catch (_) {}
                        window.preventAnonymousCreation = true;
                        const errorText = 'This password reset link is invalid or has already been used. Please request a new reset link.'
                        if (window.AuthUI && window.AuthUI.showMessage) {
                            window.AuthUI.showMessage(errorText, true);
                        }
                        const msgEl = document.getElementById('reset-link-error-message');
                        if (msgEl) msgEl.innerHTML = `<div class="alert alert-warning" role="alert">${errorText}</div>`;
                        const modalEl = document.getElementById('resetLinkErrorModal');
                        if (modalEl && typeof bootstrap !== 'undefined') {
                            const existing = bootstrap.Modal.getInstance(modalEl);
                            if (existing) existing.dispose();
                            const modal = new bootstrap.Modal(modalEl, { backdrop: 'static', keyboard: false });
                            modal.show();
                            // Clean error params from URL so they don't linger
                            try {
                                const clean = new URL(window.location.href);
                                clean.hash = '';
                                const sp2 = clean.searchParams;
                                ['error','error_code','error_description','pwreset','type','access_token','token_type','expires_in','refresh_token','provider','code','state']
                                    .forEach(k => sp2.delete(k));
                                history.replaceState({}, '', clean.toString());
                            } catch (_) {}
                            modalEl.addEventListener('hidden.bs.modal', () => {
                                setTimeout(() => { window.preventAnonymousCreation = false; }, 300);
                            }, { once: true });
                        }
                    } catch (_) {}
                    return;
                }

            if (inHash || inQuery || hasPwresetMarker) {
                __LOG_INFO__ && AppLog.info('[AuthRecovery] URL indicated recovery (hash/query/pwreset) → active', { inHash, inQuery, hasPwresetMarker });
                // Mark recovery active and wait for a valid session to arrive
                window._authRecoveryActive = true;
                try { sessionStorage.setItem('auth:pendingPasswordRecovery','true'); __LOG_INFO__ && AppLog.info('[AuthRecovery] URL indicated recovery (hash/query/pwreset) → pending flag set'); } catch(_) {}
                
                // If we already have a session, show it immediately
                const existingSession = window.currentSession || window._recoverySession;
                if (existingSession && window.AuthUI) {
                    __LOG_INFO__ && AppLog.info('[AuthRecovery] Session already exists, showing reset modal immediately');
                    updateUI(existingSession);
                    window.AuthUI.showResetUpdateModal();
                    return;
                }

                let attempts = 0;
                const maxAttempts = 120; // ~6s
                const timer = setInterval(async () => {
                    attempts++;
                    const session = window.currentSession || window._recoverySession;
                    if (session) {
                        clearInterval(timer);
                        __LOG_INFO__ && AppLog.info('[AuthRecovery] Session found during recovery poll', { hasSession: !!session });
                        updateUI(session);
                        try { 
                            if (window.AuthUI) {
                                __LOG_INFO__ && AppLog.info('[AuthRecovery] AuthUI found, showing reset modal');
                                window.AuthUI.showResetUpdateModal(); 
                            } else {
                                __LOG_WARN__ && AppLog.warn('[AuthRecovery] AuthUI not found when trying to show reset modal');
                            }
                        } catch (e) { __LOG_ERROR__ && AppLog.error('[AuthRecovery] Error calling showResetUpdateModal:', e); }
                    }
                    if (attempts >= maxAttempts) {
                        clearInterval(timer);
                        __LOG_WARN__ && AppLog.warn('[AuthRecovery] Max attempts reached without session');
                        // As a fallback, still show the modal but submission will guard on session presence
                        if (window.AuthUI) {
                            __LOG_INFO__ && AppLog.info('[AuthRecovery] Max attempts reached, showing reset modal as fallback');
                            window.AuthUI.showResetUpdateModal();
                        } else {
                            __LOG_WARN__ && AppLog.warn('[AuthRecovery] AuthUI not found when trying to show reset modal (fallback)');
                        }
                    }
                }, 50);
            }
            } catch (_) {}
        }

    // Initial session fetch (post-OAuth return included)
    AuthAPI.getSession().then((data) => {
        const session = data && data.success && data.session ? data.session : null;
        __LOG_INFO__ && AppLog.info('[AuthRecovery] Initial getSession result:', { success: data?.success, hasSession: !!session });
        if (session) {
            updateCurrentSession(session);
            updateUI(session);
                // Also sync WatchlistManager eligibility immediately
                try {
                    if (!window._authRecoveryActive && window.WatchlistManager && typeof window.WatchlistManager.updateUserState === 'function') {
                        window.WatchlistManager.updateUserState(session.user, session);
                    }
                } catch (_) {}
                // If we returned with a valid session and a pending recovery flag, open the reset modal deterministically
                try {
                    const pending = sessionStorage.getItem('auth:pendingPasswordRecovery') === 'true';
                    const url = new URL(window.location.href);
                    const isRecovery = url.searchParams.get('type') === 'recovery' || url.searchParams.get('pwreset') === '1' || url.hash.includes('type=recovery');
                    
                    if (pending || isRecovery) {
                        window._authRecoveryActive = true;
                        if (isRecovery) {
                            try { sessionStorage.setItem('auth:pendingPasswordRecovery', 'true'); } catch(_) {}
                        }
                        __LOG_INFO__ && AppLog.info('[AuthRecovery] initial getSession has session with recovery context → showing reset modal', { pending, isRecovery });
                        const s = window.currentSession || window._recoverySession;
                        updateUI(s);
                        if (window.AuthUI) {
                            window.AuthUI.showResetUpdateModal();
                        } else {
                            __LOG_WARN__ && AppLog.warn('[AuthRecovery] AuthUI not found when trying to show reset modal from initial session');
                        }
                    }
                } catch (e) { __LOG_ERROR__ && AppLog.error('[AuthRecovery] Error in initial session recovery check:', e); }
            }
            // Also detect recovery in URL on initial load
            detectRecoveryFromUrl();
            // Tidy URL params regardless
            cleanOAuthParams();
        }).catch(() => {
            detectRecoveryFromUrl();
            cleanOAuthParams();
        });
    }

    if (window.location.hash && window.location.hash.includes('access_token=')) {
        __LOG_INFO__ && AppLog.info('[AuthBridge] access_token found in hash, starting manual exchange');
        handleManualHashExchange();
    }
}

    // Update UI based on session
function updateUI(session) {
    if (!session) {
        if (window.AuthUI && typeof window.AuthUI.updateUI === 'function') {
            window.AuthUI.updateUI(null);
        }
        // Notify WatchlistManager of logged-out/guest state
        try {
            if (window.WatchlistManager && typeof window.WatchlistManager.updateUserState === 'function') {
                window.WatchlistManager.updateUserState(null, null);
            }
        } catch (_) {}
        return;
    }

    const user = session.user || {};

    const isAnonymousUser = user.is_anonymous || (!user.email && user.identities?.length === 0);
    const hasEmail = !!user.email;
    const userState = (isAnonymousUser && !hasEmail) ? 'anonymous' : 'registered';

    // Prefer Google/full name fields if present (post-OAuth), then fallback to email/Guest
    const firstIdentity = Array.isArray(user.identities) && user.identities.length > 0 ? (user.identities[0].identity_data || {}) : {};
    const displayName = (user.user_metadata?.full_name
        || user.user_metadata?.name
        || firstIdentity.full_name
        || firstIdentity.name
        || user.user_metadata?.display_name
        || (hasEmail ? user.email : 'Guest'));
    
    // If AuthUI is not yet ready, we try a robust polling mechanism
    if (window.AuthUI && typeof window.AuthUI.updateUI === 'function') {
        __LOG_INFO__ && AppLog.info('[AUTH][UPDATE_UI]', { msg: 'AuthUI ready, calling updateUI', hasSession: !!session });
        window.AuthUI.updateUI(session, displayName);
    } else {
        __LOG_WARN__ && AppLog.warn('[AUTH][UPDATE_UI] AuthUI.updateUI missing, starting poll...', { hasAuthUI: !!window.AuthUI });
        let attempts = 0;
        const maxAttempts = 20; // 10 seconds total (500ms * 20)
        const pollInterval = setInterval(() => {
            attempts++;
            if (window.AuthUI && typeof window.AuthUI.updateUI === 'function') {
                __LOG_INFO__ && AppLog.info('[AUTH][UPDATE_UI] AuthUI found via polling', { attempts });
                window.AuthUI.updateUI(session, displayName);
                clearInterval(pollInterval);
            } else if (attempts >= maxAttempts) {
                __LOG_ERROR__ && AppLog.error('[AUTH][UPDATE_UI] AuthUI poll failed after max attempts', { attempts });
                clearInterval(pollInterval);
            }
        }, 500);
    }

    // Update Watchlist eligibility/state
    try {
        if (window.WatchlistManager && typeof window.WatchlistManager.updateUserState === 'function') {
            window.WatchlistManager.updateUserState(user, session);
        }
    } catch (_) {}

    // Handle prompts
    handlePrompts(user, userState);
}

// Handle Main Auth Button Click
async function handleMainAuth() {
    __LOG_INFO__ && AppLog.info('[AUTH] handleMainAuth: clicked', { consentGiven, currentSession: !!currentSession });
    if (!consentGiven) {
        showMessage('Please accept the cookie consent to continue.', true);
        return;
    }

    if (currentSession) {
        __LOG_INFO__ && AppLog.info('[AUTH] handleMainAuth: signing out');
        await signOut();
    } else {
        __LOG_INFO__ && AppLog.info('[AUTH] handleMainAuth: showing auth modal');
        if (!window.AuthUI) {
            __LOG_ERROR__ && AppLog.error('[AUTH] handleMainAuth: window.AuthUI is missing!');
            return;
        }
        window.AuthUI.showAuthModal();
    }
}

// Replace showEmailPrompt and showPasswordPrompt with:
function showAccountUpgradePrompt() {
    if (!window.AuthUI) return;

    window.AuthUI.showUpgradeModal();

    // Set up form submission handler
    const form = window.AuthUI.getElements().upgradeForm;
    if (form && !form.hasUpgradeHandler) {
        form.hasUpgradeHandler = true; // Prevent duplicate handlers
        
        form.onsubmit = async (e) => {
            e.preventDefault();
            
            const elements = window.AuthUI.getElements();
            const email = elements.upgradeEmail?.value?.trim();
            const password = elements.upgradePassword?.value;
            const confirmPassword = elements.upgradeConfirmPassword?.value;

            // Validation
            if (!email || !password || !confirmPassword) {
                showMessage('Please fill in all fields', true);
                return;
            }

            if (password.length < 6) {
                showMessage('Password must be at least 6 characters', true);
                return;
            }

            if (password !== confirmPassword) {
                showMessage('Passwords do not match', true);
                return;
            }

            try {
                const result = await AuthAPI.upgradeAnonymous(email, password, currentSession.access_token);
                
            if (result.success) {
                trackAccountSignupSuccess('anonymous_upgrade', result);
                showMessage('Account completed! Check your email for verification.', false);

                // Close the modal properly
                window.AuthUI?.closeUpgradeModal();

                // Clear form
                if (elements.upgradeEmail) elements.upgradeEmail.value = '';
                if (elements.upgradePassword) elements.upgradePassword.value = '';
                if (elements.upgradeConfirmPassword) elements.upgradeConfirmPassword.value = '';

                startSessionRefreshTimer();
            }
            } catch (error) {
                __LOG_ERROR__ && AppLog.error('[AUTH][ERROR] Account upgrade failed', { error: error.message });
                showMessage(error.message, true);
            }
        };
    }

    // Set up "Maybe Later" button handler - but only once
    const upgradeModal = document.getElementById('upgradeModal');
    if (upgradeModal && !upgradeModal.hasMaybeLaterHandler) {
        upgradeModal.hasMaybeLaterHandler = true; // Prevent duplicate handlers
        
        const maybeLaterBtn = upgradeModal.querySelector('.btn-secondary[data-bs-dismiss="modal"]');
        if (maybeLaterBtn) {
            maybeLaterBtn.addEventListener('click', (e) => {
                e.preventDefault(); // Prevent Bootstrap's default handling
                e.stopPropagation();
                
                window.AuthUI?.closeUpgradeModal();
            });
        }
    }
}

// Simplify user state determination:
function determineUserState(user) {
    if (!user) return 'signed_out';
    
    const isAnonymousUser = user.is_anonymous || (!user.email && user.identities?.length === 0);
    const hasEmail = !!user.email;
    const userMetadata = user.user_metadata || {};
    const hasPassword = userMetadata.password_set;
    
    if (isAnonymousUser && !hasEmail) {
        return 'anonymous';
    } else if (hasEmail && hasPassword) {
        return 'registered';
    }
    
    return 'anonymous';
}

// Simplified prompt handling:
async function handlePrompts(user, userState, event = null) {
    const timeSinceCreation = getTimeSinceCreation(user.created_at);
    const userMetadata = user.user_metadata || {};
    const hasPassword = userMetadata.password_set;
    const accountCompleted = userMetadata.account_completed;
    const timeUnit = NUDGE_CONFIG.USE_MINUTES_FOR_TESTING ? 'minutes' : 'days';

    // Don't show prompts if upgrade modal is already open
    const upgradeModalOpen = document.getElementById('upgradeModal')?.classList.contains('show');
    
    if (upgradeModalOpen) {
        return;
    }

    // Only show prompt for anonymous users after threshold time
    if (userState === 'anonymous' && !accountCompleted) {
        const threshold = getTimeThreshold();
        
        if (timeSinceCreation >= threshold) {
            showAccountUpgradePrompt();
        }
    }
}

// Replace signUp function to handle confirm password:
async function signUp() {
    if (!consentGiven) {
        showMessage('Please accept cookies to proceed', true);
        return;
    }
    
    const elements = window.AuthUI?.getElements();
    const email = elements?.email?.value?.trim() || '';
    const password = elements?.password?.value || '';
    const confirmPassword = elements?.confirmPassword?.value || '';

    // Validation
    if (!email || !password) {
        showMessage('Please enter both email and password for sign up', true);
        return;
    }

    if (password.length < 6) {
        showMessage('Password must be at least 6 characters', true);
        return;
    }

    if (password !== confirmPassword) {
        showMessage('Passwords do not match', true);
        return;
    }

    try {
        let result;
        
        if (currentSession && (currentSession.user.is_anonymous || !currentSession.user.email)) {
            result = await AuthAPI.upgradeAnonymous(email, password, currentSession.access_token);
            if (result.success) {
                trackAccountSignupSuccess('anonymous_upgrade', result);
                // Close the modal after successful account upgrade request
                try {
                    window.AuthUI?.closeAuthModal();
                } catch (e) {
                    __LOG_WARN__ && AppLog.warn('[AUTH] signUp: failed to close modal during upgrade:', e);
                }
            }
            showMessage('Email confirmation sent! Verify to complete upgrade.', false);
        } else if (!currentSession) {
            result = await AuthAPI.createAccount(email, password);
            if (result.success) {
                trackAccountSignupSuccess('new_account', result);
                updateCurrentSession(result.session);
                updateUI(result.session);
                // Close the modal after successful account creation
                try {
                    window.AuthUI?.closeAuthModal();
                } catch (e) {
                    __LOG_WARN__ && AppLog.warn('[AUTH] signUp: failed to close modal:', e);
                }
            }
            showMessage('Check your email for confirmation link', false);
        } else {
            showMessage('You are already signed in. Sign out first or use Login.', true);
            return;
        }
    } catch (error) {
        __LOG_ERROR__ && AppLog.error('[AUTH][ERROR] Signup failed', { error: error.message });
        showMessage(error.message, true);
    }
}

// Sign In / Login
async function signIn() {
    if (!consentGiven) {
        showMessage('Please accept cookies to proceed', true);
        return;
    }
    
    const elements = window.AuthUI?.getElements();
    const email = elements?.email?.value?.trim() || '';
    const password = elements?.password?.value || '';

    try {
        if (!email && !password) {
            if (currentSession) {
                showMessage('Already signed in.', false);
                return;
            }
            // If anonymous is disabled, prompt for sign-in (nudge-gated) instead of creating a guest session
            const cachedAnonDisabled = (function(){ 
              try { 
                return ((typeof getCacheItem === 'function') ? getCacheItem('auth:anonDisabled') : null) === '1'; 
              } catch(_) { return false; } 
            })();
            const anonDisabled = (window.AUTH_DISABLE_ANONYMOUS === true) || (window.ANONYMOUS_DISABLED === true) || cachedAnonDisabled;
            
            if (__LOG_INFO__) dbg('SIGNIN_ANON_CHECK', {
                anonDisabled,
                window_AUTH_DISABLE_ANONYMOUS: window.AUTH_DISABLE_ANONYMOUS,
                window_ANONYMOUS_DISABLED: window.ANONYMOUS_DISABLED,
                cachedAnonDisabled
            });

            if (anonDisabled) {
                try { window.AuthNudge?.prompt('Guest access is disabled. Please sign in to continue.', 'signin_empty_anon_disabled'); } catch(_) {}
                return;
            }
            if (window.creatingAnonymousUser) {
                return;
            }
            window.creatingAnonymousUser = true;
            
            try {
                const result = await AuthAPI.makeRequest('/create-anonymous', {
                    method: 'POST'
                });
                if (result.success) {
                    updateCurrentSession(result.session);
                    updateUI(result.session);
                    showMessage('Continued as guest', false);
                }
            } catch (error) {
                const msg = String(error && error.message || '').toLowerCase();
                if (msg.includes('anonymous sign-ins are disabled') || msg.includes('anonymous signins are disabled') || msg.includes('anon') && msg.includes('disabled')) {
                    try { 
                        window.ANONYMOUS_DISABLED = true; 
                        if (typeof setCacheItem === 'function') {
                            setCacheItem('auth:anonDisabled','1', CACHE_EXPIRATION.ONE_DAY);
                        }
                    } catch(_) {}
                    try { window.AuthUI?.showAuthModal?.(); } catch(_) {}
                    showMessage('Guest access is disabled. Please sign in to continue.', true);
                } else {
                    __LOG_ERROR__ && AppLog.error('[AUTH][ERROR] Failed to create anonymous user', { error: error.message });
                    showMessage('Guest access unavailable. Please try refreshing.', true);
                }
            } finally {
                window.creatingAnonymousUser = false;
            }
            return;
        }

        if (!email || !password || password.length < 6) {
            showMessage('Email and password required for login (min 6 chars)', true);
            return;
        }

        const result = await AuthAPI.signIn(email, password);
        if (result.success) {
            updateCurrentSession(result.session);
            updateUI(result.session);
            showMessage('Signed in successfully', false);
            // Close the auth modal on successful login
            try {
                window.AuthUI?.closeAuthModal();
            } catch (e) {
                // no-op if modal not present
            }
        }
    } catch (error) {
        window.creatingAnonymousUser = false;
        __LOG_ERROR__ && AppLog.error('[AUTH][ERROR] Signin failed', { error: error.message });
        showMessage(error.message, true);
    }
}

// Sign Out
async function signOut() {
    if (!consentGiven) {
        showMessage('Please accept cookies to proceed', true);
        return;
    }
    
    window.preventAnonymousCreation = true;
    
    try {
        const result = await AuthAPI.signOut();
        if (result.success) {
            updateCurrentSession(null);
            updateUI(null);
            if (sessionRefreshInterval) {
                clearInterval(sessionRefreshInterval);
                sessionRefreshInterval = null;
            }
            showMessage('Signed out successfully', false);
        }
    } catch (error) {
        __LOG_ERROR__ && AppLog.error('[AUTH][ERROR] Signout failed', { error: error.message });
        showMessage(error.message, true);
    } finally {
        setTimeout(() => {
            window.preventAnonymousCreation = false;
        }, 1000);
    }
}

// Update Profile from dropdown
async function updateProfileFromDropdown(e) {
    e.preventDefault();
    
    let displayNameInput = document.getElementById('dropdown-display-name');
    let updateBtn = document.getElementById('dropdown-update-btn');
    if (window.AuthUI && window.AuthUI.getElements() && window.AuthUI.getElements().profileUpdateFormInput) {
        displayNameInput = window.AuthUI.getElements().profileUpdateFormInput;
    }
    if (window.AuthUI && window.AuthUI.getElements() && window.AuthUI.getElements().profileUpdateFormButton) {
        updateBtn = window.AuthUI.getElements().profileUpdateFormButton;
    }
    
    const displayName = displayNameInput?.value?.trim();

    if (!displayName) {
        showMessage('Please enter a display name', true);
        return;
    }

    // Show loading state
    const originalText = updateBtn.textContent;
    updateBtn.disabled = true;
    updateBtn.innerHTML = '<i class="bi bi-clock"></i> Updating...';

    try {
        const result = await AuthAPI.updateProfile({ display_name: displayName });
        
        if (result.success) {
            // ✅ REFRESH SESSION TO GET UPDATED USER DATA
            const sessionResult = await AuthAPI.getSession();
            if (sessionResult.success && sessionResult.session) {
                // Update current session with fresh data
                updateCurrentSession(sessionResult.session);
                
                // Update UI with fresh session data - this will populate the input field
                updateUI(sessionResult.session);
            }
            
            showMessage('Profile updated successfully!', false);
            
            // ❌ REMOVE THIS LINE - Don't clear the input after updating UI
            // displayNameInput.value = '';
        }
    } catch (error) {
        __LOG_ERROR__ && AppLog.error('Profile update failed:', error);
        showMessage(error.message || 'Profile update failed', true);
    } finally {
        // Reset button state
        updateBtn.disabled = false;
        updateBtn.innerHTML = originalText;
    }
}

// Delete User
async function deleteUser() {
    if (!consentGiven) {
        showMessage('Please accept cookies to proceed', true);
        return;
    }
    
    try {
        const result = await AuthAPI.deleteAccount();
        if (result.success) {
            updateCurrentSession(null);
            updateUI(null);
            if (sessionRefreshInterval) {
                clearInterval(sessionRefreshInterval);
                sessionRefreshInterval = null;
            }
            showMessage('Account deletion requested (contact admin)', false);
        }
    } catch (error) {
        __LOG_ERROR__ && AppLog.error('[AUTH][ERROR] User deletion failed', { error: error.message });
        showMessage(error.message, true);
    }
}

// Initialize Main content card
function initializeMainContent() {
    __LOG_INFO__ && AppLog.info('[AUTH] initializeMainContent: start');
    const container = document.getElementById('main-content-container');
    if (container && window.AuthUI) {
        __LOG_INFO__ && AppLog.info('[AUTH] initializeMainContent: AuthUI.updateUI() will handle container content');
        // No need to manually append here as AuthUI.updateUI() now handles main-content-container
    } else {
        __LOG_WARN__ && AppLog.warn('[AUTH] initializeMainContent: container or AuthUI missing', { container: !!container, AuthUI: !!window.AuthUI });
    }
}

// Initialize everything when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
    if (window.eventListenersAttached) return;
    window.eventListenersAttached = true;
    __LOG_INFO__ && AppLog.info('[AUTH] DOMContentLoaded: start');
    
    // Initialize main content card first
    initializeMainContent();
    
    // Wait for AuthUI to be ready
    const attachListeners = () => {
        __LOG_INFO__ && AppLog.info('[AUTH] attachListeners: start');
        if (!window.AuthUI) {
            __LOG_WARN__ && AppLog.warn('[AUTH] attachListeners: window.AuthUI missing, retrying in 100ms');
            setTimeout(attachListeners, 100);
            return;
        }
        
        const elements = window.AuthUI.getElements();
        __LOG_INFO__ && AppLog.info('[AUTH] attachListeners: elements found:', {
            mainAuthBtn: !!elements.mainAuthBtn,
            authForm: !!elements.authForm,
            signupBtn: !!elements.signupBtn,
            signinBtn: !!elements.signinBtn
        });
        
        if (!elements.mainAuthBtn) {
            __LOG_WARN__ && AppLog.warn('[AUTH] attachListeners: mainAuthBtn missing, retrying in 100ms');
            setTimeout(attachListeners, 100);
            return;
        }
        // Inline message helpers for modals
        function renderInlineMessage(containerEl, text, type = 'info') {
            if (window.AuthUI && window.AuthUI.renderInlineMessage) {
                window.AuthUI.renderInlineMessage(containerEl, text, type);
            }
            
            if (!containerEl) return;
            const cls = type === 'error' ? 'alert-danger' : (type === 'success' ? 'alert-success' : 'alert-info');
            containerEl.innerHTML = `<div class="alert ${cls} py-2 mb-0" role="alert">${text}</div>`;
        }
        function clearInlineMessage(containerEl) { if (containerEl) containerEl.innerHTML = ''; }
        
        // Main auth button
        if (elements.mainAuthBtn) {
            __LOG_INFO__ && AppLog.info('[AUTH] attachListeners: binding handleMainAuth to mainAuthBtn');
            elements.mainAuthBtn.addEventListener('click', handleMainAuth);
        }
        
        // Form submission (handles signin)
        if (elements.authForm) {
            elements.authForm.addEventListener('submit', (e) => {
                e.preventDefault();
                window.AuthUI?.toggleConfirmPasswordField(false);
                signIn();
            });
        }
        
        // Signup button - show confirm password field and call signUp
        if (elements.signupBtn) {
            elements.signupBtn.addEventListener('click', (e) => {
                e.preventDefault();
                window.AuthUI?.toggleConfirmPasswordField(true);
                signUp();
            });
        }
        
        // Signin button - explicitly trigger signIn
        if (elements.signinBtn) {
            elements.signinBtn.addEventListener('click', (e) => {
                e.preventDefault();
                window.AuthUI?.toggleConfirmPasswordField(false);
                signIn();
            });
        }

        // Google Sign-in (OAuth via Supabase)
        if (elements.googleSigninBtn) {
            elements.googleSigninBtn.addEventListener('click', async (e) => {
                e.preventDefault();
                try {
                    // Close the modal before navigating to the provider
                    window.AuthUI?.closeAuthModal();

                    const redirectTo = (typeof window.getAuthReturnUrl === 'function') ? window.getAuthReturnUrl(false) : window.location.href;

                    // Server-initiated OAuth (no Supabase client on frontend)
                    const url = '/api/auth/oauth/start?provider=google&flow=pkce&redirect_to=' + encodeURIComponent(redirectTo);
                    window.location.assign(url);
                } catch (err) {
                    // If user cancels or an error occurs before navigation
                    const msg = (err && err.message) ? err.message : 'Google sign-in failed';
                    showMessage(msg, true);
                    // Reopen modal so user can try other methods
                    window.AuthUI?.showAuthModal();
                }
            });
        }

        // Google Sign-in from Upgrade modal (OAuth via Supabase)
        if (elements.googleUpgradeBtn) {
            elements.googleUpgradeBtn.addEventListener('click', async (e) => {
                e.preventDefault();
                try {
                    // Close the upgrade modal before navigating to the provider
                    window.AuthUI?.closeUpgradeModal();

                    const redirectTo = (typeof window.getAuthReturnUrl === 'function') ? window.getAuthReturnUrl(false) : window.location.href;

                    // Server-initiated OAuth (no Supabase client on frontend)
                    const url = '/api/auth/oauth/start?provider=google&flow=pkce&redirect_to=' + encodeURIComponent(redirectTo);
                    window.location.assign(url);
                } catch (err) {
                    const msg = (err && err.message) ? err.message : 'Google sign-in failed';
                    showMessage(msg, true);
                    // Reopen the upgrade modal so the user can try email/password instead
                    window.AuthUI?.showUpgradeModal();
                }
            });
        }

        // Facebook Sign-in (OAuth via Supabase)
        if (elements.facebookSigninBtn) {
            elements.facebookSigninBtn.addEventListener('click', async (e) => {
                e.preventDefault();
                try {
                    window.AuthUI?.closeAuthModal();
                    const redirectTo = (typeof window.getAuthReturnUrl === 'function') ? window.getAuthReturnUrl(false) : window.location.href;
                    // Server-initiated OAuth (no Supabase client on frontend)
                    const url = '/api/auth/oauth/start?provider=facebook&flow=pkce&redirect_to=' + encodeURIComponent(redirectTo);
                    window.location.assign(url);
                } catch (err) {
                    showMessage((err && err.message) ? err.message : 'Facebook sign-in failed', true);
                    window.AuthUI?.showAuthModal();
                }
            });
        }

        // Facebook Sign-in from Upgrade modal (OAuth via Supabase)
        if (elements.facebookUpgradeBtn) {
            elements.facebookUpgradeBtn.addEventListener('click', async (e) => {
                e.preventDefault();
                try {
                    window.AuthUI?.closeUpgradeModal();
                    const redirectTo = (typeof window.getAuthReturnUrl === 'function') ? window.getAuthReturnUrl(false) : window.location.href;
                    // Server-initiated OAuth (no Supabase client on frontend)
                    const url = '/api/auth/oauth/start?provider=facebook&flow=pkce&redirect_to=' + encodeURIComponent(redirectTo);
                    window.location.assign(url);
                } catch (err) {
                    showMessage((err && err.message) ? err.message : 'Facebook sign-in failed', true);
                    window.AuthUI?.showUpgradeModal();
                }
            });
        }

        // Forgot password link
        if (elements.forgotPasswordLink && !elements.forgotPasswordLink._handlerAttached) {
            elements.forgotPasswordLink._handlerAttached = true;
            elements.forgotPasswordLink.addEventListener('click', (e) => {
                e.preventDefault();
                window.AuthUI?.closeAuthModal();
                window.AuthUI?.showResetRequestModal();
            });
        }

        // Reset request form submit
        if (elements.resetRequestForm && !elements.resetRequestForm._handlerAttached) {
            elements.resetRequestForm._handlerAttached = true;
            elements.resetRequestForm.addEventListener('submit', async (e) => {
                e.preventDefault();
                try {
                    const emailInput = elements.resetEmail;
                    let raw = emailInput?.value ?? '';
                    // Normalize: remove zero-width chars and newlines, trim, lowercase
                    raw = String(raw).replace(/[\u200B-\u200D\uFEFF]/g, '').replace(/\r?\n/g, '');
                    const email = raw.trim().toLowerCase();
                    // Feed normalized value back into the input so built-in validity checks use it
                    if (emailInput) emailInput.value = email;
                    if (!email) {
                        renderInlineMessage(elements.resetRequestMessage, 'Please enter your email', 'error');
                        emailInput && emailInput.focus();
                        __LOG_INFO__ && AppLog.info('[AuthRecovery] Reset request: empty email after normalization');
                        return;
                    }
                    // Use a permissive sanity check to avoid false negatives from HTML5 validity quirks
                    const isBasicEmail = /.+@.+\..+/.test(email);
                    if (!isBasicEmail) {
                        renderInlineMessage(elements.resetRequestMessage, 'Please enter a valid email address', 'error');
                        try { emailInput && emailInput.focus(); } catch (_) {}
                        __LOG_INFO__ && AppLog.info('[AuthRecovery] Reset request: basic email sanity check failed', { email });
                        return;
                    }

                    const btn = elements.sendResetLinkBtn;
                    const originalText = btn ? btn.innerHTML : '';
                    if (btn) { btn.disabled = true; btn.innerHTML = 'Sending…'; }

                    const redirectTo = (typeof window.getAuthReturnUrl === 'function') ? window.getAuthReturnUrl(false, true) : window.location.href;
                    // Mark that we are in a pending password recovery flow so we can deterministically open the reset modal on return
                    try { sessionStorage.setItem('auth:pendingPasswordRecovery', 'true'); __LOG_INFO__ && AppLog.info('[AuthRecovery] Marked pendingPasswordRecovery before sending email'); } catch (_) {}

                    // Diagnostics: log context (mask email)
                    const startedAt = performance.now();
                    const maskedEmail = email.replace(/(^.).*(@.*$)/, (m, a, b) => a + '***' + b);
                    __LOG_INFO__ && AppLog.info('[AuthRecovery][request] About to call resetPasswordForEmail', {
                        email: maskedEmail,
                        redirectTo,
                        origin: window.location.origin,
                        pathname: window.location.pathname
                    });

                    let rspError = null;
                    try {
                        const result = await AuthAPI.resetPassword(email);
                        if (!result.success) {
                            rspError = new Error(result.error || 'Failed to send reset email');
                            rspError.status = result.status;
                        }
                    } catch (e) {
                        rspError = e;
                    }

                    const durationMs = Math.round(performance.now() - startedAt);
                    if (!rspError) {
                        __LOG_INFO__ && AppLog.info('[AuthRecovery][request] resetPasswordForEmail: SUCCESS', { durationMs });
                        renderInlineMessage(elements.resetRequestMessage, 'If an account exists for this email, a reset link has been sent.', 'success');
                        // Auto-close the modal after 5 seconds so the user can read the success message
                        try { setTimeout(() => { window.AuthUI?.closeResetRequestModal(); }, 5000); } catch (_) {}
                    } else {
                        const safeErr = {
                            name: rspError?.name,
                            message: rspError?.message,
                            status: rspError?.status,
                            code: rspError?.code,
                        };
                        __LOG_WARN__ && AppLog.warn('[AuthRecovery][request] resetPasswordForEmail: ERROR', { durationMs, error: safeErr, redirectTo });

                        let inlineMsg = rspError?.message || 'Failed to send reset email.';
                        if (rspError?.status === 400) {
                            inlineMsg += ' (Check Supabase Authentication → Redirect URLs: allowlist this exact URL, including scheme/host/port/path' + (redirectTo.includes('pwreset=1') ? ' and the ?pwreset=1 variant' : '') + '.)';
                        }
                        renderInlineMessage(elements.resetRequestMessage, inlineMsg, 'error');
                    }
                } catch (err) {
                    const inlineMsg = err?.message || 'Failed to send reset email';
                    __LOG_WARN__ && AppLog.warn('[AuthRecovery][request] Unexpected exception in reset handler', { message: inlineMsg });
                    renderInlineMessage(elements.resetRequestMessage, inlineMsg, 'error');
                } finally {
                    const btn = elements.sendResetLinkBtn;
                    if (btn) { btn.disabled = false; btn.innerHTML = 'Send reset link'; }
                }
            });
        }

        // Wire up password visibility toggle and strength meter for reset form
        if (elements.toggleNewPasswordVisibility && !elements.toggleNewPasswordVisibility._handlerAttached) {
            elements.toggleNewPasswordVisibility._handlerAttached = true;
            elements.toggleNewPasswordVisibility.addEventListener('click', () => {
                const input = elements.newPassword;
                if (!input) return;
                const isPwd = input.type === 'password';
                input.type = isPwd ? 'text' : 'password';
                elements.toggleNewPasswordVisibility.innerHTML = isPwd ? '<i class="bi bi-eye-slash"></i>' : '<i class="bi bi-eye"></i>';
            });
        }

        function evaluateStrength(pw) {
            let score = 0;
            if (!pw) return 0;
            const lengthScore = Math.min(4, Math.floor(pw.length / 3)); // up to 4
            const variety = [/[a-z]/, /[A-Z]/, /\d/, /[^A-Za-z0-9]/].reduce((acc, re) => acc + (re.test(pw) ? 1 : 0), 0);
            score = lengthScore + variety; // 0..8
            return Math.min(score, 8);
        }

        function updateStrengthUI() {
            const pw = elements.newPassword?.value || '';
            const bar = elements.newPasswordStrengthBar;
            const text = elements.newPasswordStrengthText;
            const submit = elements.resetPasswordSubmitBtn;
            const score = evaluateStrength(pw);
            const pct = Math.round((score / 8) * 100);
            if (bar) {
                bar.style.width = pct + '%';
                bar.classList.remove('bg-danger','bg-warning','bg-success');
                if (score < 3) bar.classList.add('bg-danger');
                else if (score < 6) bar.classList.add('bg-warning');
                else bar.classList.add('bg-success');
            }
            if (text) {
                let label = 'Weak';
                if (score >= 6) label = 'Strong'; else if (score >= 3) label = 'Medium';
                text.textContent = `Strength: ${label}`;
            }
            if (submit) {
                submit.disabled = (pw.length < 8);
            }
        }

        if (elements.newPassword && !elements.newPassword._strengthHandler) {
            elements.newPassword._strengthHandler = true;
            elements.newPassword.addEventListener('input', updateStrengthUI);
        }
        if (elements.confirmNewPassword && !elements.confirmNewPassword._strengthHandler) {
            elements.confirmNewPassword._strengthHandler = true;
            elements.confirmNewPassword.addEventListener('input', updateStrengthUI);
        }
        // Initialize once if modal is already visible
        try { updateStrengthUI(); } catch (_) {}

        // Reset update form submit
        if (elements.resetUpdateForm && !elements.resetUpdateForm._handlerAttached) {
            elements.resetUpdateForm._handlerAttached = true;
            elements.resetUpdateForm.addEventListener('submit', async (e) => {
                e.preventDefault();
                try {
                    const newPw = elements.newPassword?.value || '';
                    const confirmPw = elements.confirmNewPassword?.value || '';
                    if (newPw.length < 8) { renderInlineMessage(elements.resetUpdateMessage, 'Password must be at least 8 characters', 'error'); return; }
                    if (newPw !== confirmPw) { renderInlineMessage(elements.resetUpdateMessage, 'Passwords do not match', 'error'); return; }

                    // Ensure a recovery session is present
                    const session = window.currentSession || window._recoverySession || getStoredSession();
                    if (!session || !session.access_token) {
                        renderInlineMessage(elements.resetUpdateMessage, 'Recovery session not found. Please click the reset link again or refresh this page.', 'error');
                        return;
                    }

                    const btn = elements.resetPasswordSubmitBtn;
                    const originalText = btn ? btn.innerHTML : '';
                    if (btn) { btn.disabled = true; btn.innerHTML = 'Updating…'; }

                    try {
                        const result = await AuthAPI.updatePassword(newPw);
                        if (!result.success) throw new Error(result.error || 'Failed to update password');
                    } catch (error) {
                        throw error;
                    }

                    renderInlineMessage(elements.resetUpdateMessage, 'Your password has been updated. Please re-login to your account with the new password.', 'success');

                    // Clean URL hash/query of recovery params prior to sign out
                    try {
                        const url = new URL(window.location.href);
                        url.hash = '';
                        const p = url.searchParams;
                        ['type','access_token','token_type','expires_in','refresh_token','provider','code','state','error','error_code','error_description','pwreset','email-confirmation']
                            .forEach(k => p.delete(k));
                        history.replaceState({}, '', url.toString());
                    } catch (_) {}

                    // Sign out to avoid leaving a logged-in session after recovery
                    try {
                        window.preventAnonymousCreation = true;
                        await AuthAPI.signOut();
                    } catch (_) {}
                    finally {
    // Clear recovery flags and any stored session
    window._authRecoveryActive = false;
    try { 
        sessionStorage.removeItem('auth:pendingPasswordRecovery'); 
        __LOG_INFO__ && AppLog.info('[AuthRecovery] Password updated → cleared pending flag'); 
    } catch (_) {}
    try { 
        window._recoverySession = null;
        updateCurrentSession(null); 
        updateUI(null); 
    } catch (_) {}
                        setTimeout(() => { window.preventAnonymousCreation = false; }, 1000);
                    }

                    // Close the reset modal after 5 seconds and show the login modal so user signs in with new password
                    setTimeout(() => {
                        try { window.AuthUI?.closeResetUpdateModal(); } catch (_) {}
                        try { window.AuthUI?.showAuthModal(); } catch (_) {}
                    }, 5000);
                } catch (err) {
                    renderInlineMessage(elements.resetUpdateMessage, err?.message || 'Failed to update password', 'error');
                } finally {
                    const btn = elements.resetPasswordSubmitBtn;
                    if (btn) { btn.disabled = false; btn.innerHTML = 'Update password'; }
                }
            });
        }
        
        // Profile dropdown listeners
        if (elements.profileUpdateForm) {
            elements.profileUpdateForm.addEventListener('submit', updateProfileFromDropdown);
        }
        if (elements.dropdownSignoutBtn) {
            elements.dropdownSignoutBtn.addEventListener('click', signOut);
        }
        if (elements.dropdownDeleteBtn) {
            elements.dropdownDeleteBtn.addEventListener('click', deleteUser);
        }
        // Add listener for Register Account button
        if (elements.dropdownRegisterBtn) {
            elements.dropdownRegisterBtn.addEventListener('click', () => {
                showAccountUpgradePrompt();
            });
        }

        // Ensure tooltip on Manage Watchlists (re-init after DOM ready)
        const manageBtn = document.getElementById('manage-watchlists-btn');
        if (window.WatchlistManager && typeof window.WatchlistManager.setupManageWatchlistsTooltip === 'function') {
            window.WatchlistManager.setupManageWatchlistsTooltip();
        } else if (manageBtn) {
            // Fallback: attach tooltip directly to the button
            manageBtn.setAttribute('data-bs-toggle', 'tooltip');
            manageBtn.setAttribute('data-bs-placement', 'top');
            if (!manageBtn.title) {
                manageBtn.title = 'You need to be logged into a registered account to be able to create and save a watchlist';
            }
            if (typeof bootstrap !== 'undefined' && bootstrap.Tooltip) {
                const existing = bootstrap.Tooltip.getInstance(manageBtn);
                if (existing) existing.dispose();
                new bootstrap.Tooltip(manageBtn);
            }
        }
    };
    
    attachListeners();

    // Initialize cookie consent
    const cookieScript = document.getElementById('cookieconsent-script');
    if (cookieScript) {
        cookieScript.addEventListener('load', () => {
            setTimeout(initializeCookieConsent, 100);
        });
        cookieScript.addEventListener('error', () => {
            __LOG_ERROR__ && AppLog.error('[AUTH][ERROR] CookieConsent script failed to load');
        });
    }

    // Fallback consent init
    setTimeout(() => {
        __LOG_INFO__ && AppLog.info('[AUTH] Fallback consent init check: consentInitialized=', consentInitialized);
        if (!consentInitialized) {
            initializeCookieConsent();
        }
    }, 1000);
});

// Helper to get display name from user
function getDisplayName(user) {
    return user.user_metadata?.display_name || user.email || 'Guest';
}

// Helper to compute a safe return URL back to the current page (no hard-coded path)
// includeEmailFlag: when true, ensure the UI is notified that email confirmation succeeded (uses sessionStorage where possible)
// includePwResetFlag: when true, ensure the UI is notified that password reset is active (uses sessionStorage where possible)
function getAuthReturnUrl(includeEmailFlag = false, includePwResetFlag = false) {
    try {
        // Build from origin + pathname only (no existing hash), then add safe query params
        // Fix: Use window.location.href directly to ensure any existing ports/params from current state are considered,
        // but then we explicitly strip the hash as per original logic.
        const url = new URL(window.location.href);
        // Fix: If the path ends with '/*', remove it as it's a known artifact causing broken redirect links
        if (url.pathname.endsWith('/*')) {
            url.pathname = url.pathname.slice(0, -2) || '/';
        }
        if (url.hostname === 'localhost' || url.hostname === '127.0.0.1') {
            try { __LOG_WARN__ && AppLog.warn('[AuthRedirect][client] Detected localhost in return URL. Backend will attempt to override with server IP.', { href: window.location.href }); } catch (_) {}
        }
        url.hash = '';
        const p = url.searchParams;

        // NEW: Instead of polluting the URL that goes into emails or social redirects, 
        // we use sessionStorage for same-browser state persistence.
        if (includeEmailFlag) {
            try { sessionStorage.setItem('auth:email_confirmation', 'success'); } catch (_) {}
        }
        if (includePwResetFlag) {
            try { sessionStorage.setItem('auth:pendingPasswordRecovery', 'true'); } catch (_) {}
        }

        const finalUrl = url.toString();
        try { __LOG_INFO__ && AppLog.info('[AuthRedirect][client] getAuthReturnUrl()', { includeEmailFlag, includePwResetFlag, origin: window.location.origin, pathname: window.location.pathname, finalUrl }); } catch (_) {}
        return finalUrl;
    } catch (e) {
        // Fallback to origin root
        try {
            const u = new URL('/', window.location.origin);
            if (includeEmailFlag) {
                try { sessionStorage.setItem('auth:email_confirmation', 'success'); } catch (_) {}
            }
            if (includePwResetFlag) {
                try { sessionStorage.setItem('auth:pendingPasswordRecovery', 'true'); } catch (_) {}
            }
            u.hash = '';
            const finalUrl = u.toString();
            try { __LOG_INFO__ && AppLog.info('[AuthRedirect][client] getAuthReturnUrl() fallback-origin', { includeEmailFlag, includePwResetFlag, origin: window.location.origin, finalUrl }); } catch (_) {}
            return finalUrl;
        } catch (_) {
            try { __LOG_INFO__ && AppLog.info('[AuthRedirect][client] getAuthReturnUrl() ultimate-fallback', { href: window.location.href }); } catch (__) {}
            return (window.location.origin + window.location.pathname);
        }
    }
}

// Expose globally for other modules loaded earlier
window.getAuthReturnUrl = getAuthReturnUrl;
__LOG_INFO__ && AppLog.info('[AUTH] getAuthReturnUrl exposed on window');

// Ensure AuthAPI is accessible on window for other modules (device-link-ui, etc.)
(function() {
    try {
        window.AuthAPI = AuthAPI;
        if (!window.auth) window.auth = {};
        window.auth.AuthAPI = AuthAPI;
        __LOG_INFO__ && AppLog.info('[AUTH] AuthAPI exposed on window');
    } catch(e) {
        __LOG_WARN__ && AppLog.warn('[AUTH] Failed to expose AuthAPI on window:', e.message);
    }
})();
